<template>
    <div>
        <f-dialog
            v-model       = "edit"
            :width        = "600"
            :show-header  = "false"
            :hide-actions = "false"
            :store-label  = "$t('dms.props.store')"
            content-class = "dialog-border"
            @cancel       = "onCancel"
            @store        = "onStore"
        >
            <template v-slot:content>
                <div style="position: relative" class="pl-2">
                    <div class="close-button">
                        <c-toolbar-button
                            size     = "28"
                            color    = "red"
                            icon     = "mdi-close"
                            :tooltip = "$t('common.cancel')"
                            @click   = "onCancel"
                        />
                    </div>


                        <v-switch
                            :ripple = "false"
                            v-model="allunits"
                        >
                            <template v-slot:label>
                                <div style="    font-size: 15px; font-weight: 600 ">
                                    {{ allunits ? $t('dms.props.assign.all') :  $t('dms.props.assign.unit', [ unit.fabricNo ]) }}
                                </div>
                            </template>
                        </v-switch>

                    <div class="v-flex">
                        <f-enum-select
                            v-model  = "type"
                            label    = "Dokumentenart"
                            module   = "inc"
                            type     = "stepdoctypes"
                            :exclude = "exclude"
                        />
                        <v-switch
                            v-if    = "isPrivileged"
                            class   = "ml-2"
                            v-model = "force"
                            :ripple = "false"
                        >
                            <template v-slot:label>
                                <v-icon size="22" color="primary">mdi-content-save-move</v-icon>
                            </template>
                        </v-switch>
                    </div>

                    <div class="v-flex">
                        <v-text-field
                            label = "Dateiname"
                            v-model="filename"
                        />
                        <div class="file-extension">
                            {{ extension }}
                        </div>
                    </div>
                </div>
            </template>
        </f-dialog>
    </div>
</template>

<script>

import Inc            from "@/modules/inc/service/Inc";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import FDialog        from "@/modules/core/components/utils/FDialog.vue";
import FEnumSelect    from "@/modules/core/components/utils/FEnumSelect.vue";
import Dms from "@/modules/dms/common/service/Dms";
import Core from "@/modules/core/service/Core";

export default {
    name: "PDmsProperties",

    components: {
        FEnumSelect,
        CToolbarButton,
        FDialog
    },

    props: {
        stepDataId: {

        },

        category: {

        },

        document: {

        },

        value: {

        }
    },

    data() {
        return {
            allunits    : false,
            type        : null,
            filename    : null,
            edit        : false,
            extension   : null,
            force       : false,
            exclude     : [],
            stepdoctypes: []
        };
    },

    computed: {
        unit () {
            return this.$store.getters.site;
        },

        isImage () {
            return this.document.type.id === 8;
        },

        isMail () {
            return this.extension === ".msg" || this.extension === ".eml";
        },

        isPdf () {
            return this.extension === ".pdf" || this.extension === ".PDF";
        },

        isPrivileged () {
            return Core.security.isPrivileged();
        },

        stepDocTypeOIds () {
            return this.$store.getters.inc.stepdoctypesIds;
        },

        imageDocTypesExcludes () {
            return this.stepDocTypeOIds.filter(id => ![8].includes(id));
        },

        mailDocTypesExcludes () {
            return this.stepDocTypeOIds.filter(id => ![0,1,5].includes(id));
        },

        pdfDocTypesExcludes () {
            return this.stepDocTypeOIds.filter(id => ![0,2,3,4,5,6,7,10,11,12,13,14,15,20,22,23,24].includes(id));
        },
    },

    watch: {
        value () {
            this.edit = this.value;
            if (this.edit) {
                this.force = false;
                this.filename  = this.document.name.slice(0, this.document.name.lastIndexOf("."));
                this.extension = "." + this.document.name.slice((this.document.name.lastIndexOf(".") - 1 >>> 0) + 2);

                if (this.isImage) {
                    this.exclude = this.imageDocTypesExcludes;
                } else if (this.isMail) {
                    this.exclude = this.mailDocTypesExcludes;
                } else if (this.isPdf) {
                    this.exclude = this.pdfDocTypesExcludes;
                }

                switch (this.category) {
                    case "invoiceService":
                        if (this.isPdf) {
                            this.exclude.push(1,2,4,12,13);
                        }
                        break;
                    case "issueService":
                        if (this.isPdf) {
                            this.exclude.push(2,4,12,13);
                        }
                        break;
                    case "assessmentService":
                    case "maintenanceService":
                    case "repairService":
                }

                this.allunits  = !this.document.unitId;
                this.type      = this.document.type;
            }
        }
    },

    methods: {
        onCancel () {
            this.$emit("input", false);
        },

        onStore () {
            Inc.document.properties(this, this.document.id, {
                allunits: this.allunits,
                unitId  : this.unit.id,
                name    : this.filename + this.extension,
                type    : this.type,
                force   : this.force
            }).then((data) => {
                this.$bus.$emit(Dms.event.document.refresh, {
                    id       : this.stepDataId,
                    documents: data
                });
                Core.message.hint(this,  this.$t("dms.entry.message.properties"));
                this.$emit("input", false);
            })
            .catch(() => {})
        },
    }
}
</script>

<style scoped>

.close-button {
    position: absolute;
    z-index: 10;
    right: 0;
    top: 0;
}

.file-extension {
    font-size: 15px;
    margin-top: 22px;
    margin-left: 8px;
}

</style>